import { createContext } from "react";

export const ContextFileControl = createContext(null);
